var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "flex flex-col desktop:flex-row" }, [
    _c(
      "div",
      { staticClass: "form-box w-full desktop:w-1/2 p-8" },
      [
        _c("h2", { staticClass: "!text-xl !font-bold" }, [
          _vm._v(_vm._s(_vm.$t("blog.owners.simulate-income")))
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "font-bold mt-10" }, [
          _vm._v(_vm._s(_vm.$t("blog.owners.select-aircraft-type")))
        ]),
        _vm._v(" "),
        _c("form-select", {
          staticClass: "mt-6 w-72 h-10 rounded-sm max-w-full",
          attrs: {
            items: _vm.planeModels,
            "item-value": "id",
            "item-text": "name"
          },
          model: {
            value: _vm.selectedPlaneModelId,
            callback: function($$v) {
              _vm.selectedPlaneModelId = $$v
            },
            expression: "selectedPlaneModelId"
          }
        }),
        _vm._v(" "),
        _c("p", { staticClass: "text-xs mt-8" }, [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$t("blog.owners.footnote", {
                  pricePerHour: _vm.selectedPlaneModel.hourPrice
                })
              ) +
              "\n        "
          )
        ])
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "result-box w-full desktop:w-1/2 relative" }, [
      _c("div", { staticClass: "absolute bg-white income-box" }, [
        _c("div", { staticClass: "income" }, [
          _vm._v(
            _vm._s(_vm.$t("blog.owners.income-by-year", { income: _vm.income }))
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "income-info" }, [
          _vm._v(_vm._s(_vm.$t("blog.owners.income-info")))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-01cee7df", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01cee7df","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/OwnerIncomeSimulator.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-01cee7df","hasScoped":true,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/OwnerIncomeSimulator.vue
// module chunks = 1 2 3